import React, { useContext, useEffect, useState } from "react";

const ProductInfo = ({ data, setData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({
      ...prev,
      productInfo: { ...prev.productInfo, [name]: value }
    }));
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#999DF8] w-4 h-4 rounded" />
        <h1>Product Info</h1>
      </div>

      <div>
        <div className="my-4">
          <label htmlFor="" className="">
            Title
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]   rounded-lg my-2">
            <input
              name="title"
              value={data.productInfo?.title || ''} 
              onChange={handleChange}
              type="text"
              placeholder="Product title goes here"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>
        <div className="my-4">
          <label htmlFor="" className="">
            Unique Value Propsition
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
            name="description"
              value={data.productInfo?.description || ""}
              onChange={handleChange}
              type="text"
              placeholder="Short description"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
